



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// rejectPlan
// REJECTPLAN


const REJECTPLAN= createAsyncThunk(
  "rejectPlan/rejectPlan",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const rejectPlanSlice = createSlice({
  name: "rejectPlanSlice",
  initialState: {
    rejectPlan: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfrejectPlan: (state) => {
        state.rejectPlan.loading = false
        state.rejectPlan.error = false
        state.rejectPlan.data = []
        state.rejectPlan.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(REJECTPLAN.fulfilled, (state, action) => {
      state.rejectPlan = {
        ...state.rejectPlan,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REJECTPLAN.pending, (state, action) => {
      state.rejectPlan = {
        ...state.rejectPlan,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REJECTPLAN.rejected, (state, action) => {
      state.rejectPlan = {
        ...state.rejectPlan,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const rejectPlanAction = {
    REJECTPLAN,
};

export { rejectPlanAction };
export default rejectPlanSlice.reducer;
export const {setInitialStateOfrejectPlan} = rejectPlanSlice.actions
